import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'rainbow-banner',
    templateUrl: './rainbow.component.html',
    styleUrls: ['./rainbow.component.css'],
    standalone: false
})
export class RainbowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
